"use strict";

var _defineProperty = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/defineProperty.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransactionProcessor = void 0;
const transactions_builder_1 = require("./transactions-builder");
class TransactionProcessor {
  constructor(connection, wallet) {
    let commitment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "confirmed";
    _defineProperty(this, "connection", void 0);
    _defineProperty(this, "wallet", void 0);
    _defineProperty(this, "commitment", void 0);
    this.connection = connection;
    this.wallet = wallet;
    this.commitment = commitment;
  }
  async signTransaction(txRequest) {
    const {
      transactions,
      lastValidBlockHeight,
      blockhash
    } = await this.signTransactions([txRequest]);
    return {
      transaction: transactions[0],
      lastValidBlockHeight,
      blockhash
    };
  }
  async signTransactions(txRequests) {
    const {
      blockhash,
      lastValidBlockHeight
    } = await this.connection.getLatestBlockhash(this.commitment);
    const feePayer = this.wallet.publicKey;
    const pSignedTxs = txRequests.map(txRequest => {
      return rewriteTransaction(txRequest, feePayer, blockhash);
    });
    const transactions = await this.wallet.signAllTransactions(pSignedTxs);
    return {
      transactions,
      lastValidBlockHeight,
      blockhash
    };
  }
  async sendTransaction(transaction, lastValidBlockHeight, blockhash) {
    const execute = this.constructSendTransactions([transaction], lastValidBlockHeight, blockhash);
    const txs = await execute();
    const ex = txs[0];
    if (ex.status === "fulfilled") {
      return ex.value;
    } else {
      throw ex.reason;
    }
  }
  constructSendTransactions(transactions, lastValidBlockHeight, blockhash) {
    let parallel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    const executeTx = async tx => {
      const rawTxs = tx.serialize();
      return this.connection.sendRawTransaction(rawTxs, {
        preflightCommitment: this.commitment
      });
    };
    const confirmTx = async txId => {
      const result = await this.connection.confirmTransaction({
        signature: txId,
        lastValidBlockHeight: lastValidBlockHeight,
        blockhash
      }, this.commitment);
      if (result.value.err) {
        throw new Error("Transaction failed: ".concat(JSON.stringify(result.value)));
      }
    };
    return async () => {
      if (parallel) {
        const results = transactions.map(async tx => {
          const txId = await executeTx(tx);
          await confirmTx(txId);
          return txId;
        });
        return Promise.allSettled(results);
      } else {
        const results = [];
        for (const tx of transactions) {
          const txId = await executeTx(tx);
          await confirmTx(txId);
          results.push(txId);
        }
        return Promise.allSettled(results);
      }
    };
  }
  async signAndConstructTransaction(txRequest) {
    const {
      transaction,
      lastValidBlockHeight,
      blockhash
    } = await this.signTransaction(txRequest);
    return {
      signedTx: transaction,
      execute: async () => this.sendTransaction(transaction, lastValidBlockHeight, blockhash)
    };
  }
  async signAndConstructTransactions(txRequests) {
    let parallel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const {
      transactions,
      lastValidBlockHeight,
      blockhash
    } = await this.signTransactions(txRequests);
    const execute = this.constructSendTransactions(transactions, lastValidBlockHeight, blockhash, parallel);
    return {
      signedTxs: transactions,
      execute
    };
  }
}
exports.TransactionProcessor = TransactionProcessor;
function rewriteTransaction(txRequest, feePayer, blockhash) {
  if ((0, transactions_builder_1.isVersionedTransaction)(txRequest.transaction)) {
    let tx = txRequest.transaction;
    if (txRequest.signers) {
      var _txRequest$signers;
      tx.sign((_txRequest$signers = txRequest.signers) !== null && _txRequest$signers !== void 0 ? _txRequest$signers : []);
    }
    return tx;
  } else {
    var _txRequest$signers2;
    let tx = txRequest.transaction;
    let signers = (_txRequest$signers2 = txRequest.signers) !== null && _txRequest$signers2 !== void 0 ? _txRequest$signers2 : [];
    tx.feePayer = feePayer;
    tx.recentBlockhash = blockhash;
    signers.forEach(kp => {
      tx.partialSign(kp);
    });
    return tx;
  }
}
//# sourceMappingURL=transactions-processor.js.map